import { useAppDispatch } from '../../../../../../../app/redux/hooks';
import { updateToast } from '../../../../../../redux/reducer/commonSlices/toastSlice';

//custom hook to handle form submit
export const useContactFormSubmission = (URLs: any, captchaRef: any, reset: any) => {
  const dispatch = useAppDispatch();

  const phoneNumber = (value: string) => {
    const countryCodeLength = value.length - 10;
    const components = {
      IDDCC: value?.substring(0, countryCodeLength),
      NN: value?.substring(countryCodeLength, value.length)
    };
    return components?.NN;
  };

  const onSubmit = async (data: any) => {
    const token = (captchaRef.current as any).getValue();
    if (token) {
      (captchaRef.current as any).reset();
      let payload: any = {
        ...data,
        phone: phoneNumber(data.phone),
        googleRecaptchaResponse: token
      };
      await dispatch(URLs[0]?.url(payload));
      reset();
    } else if (!token) {
      dispatch(
        updateToast({
          show: true,
          message: 'Captcha Verification is required',
          severity: 'warning'
        })
      );
    }
  };

  return { onSubmit };
};
